import ShopModal from './ShopModal.view';

export default ShopModal;